import React, {useState} from 'react';
import style from './Comment.module.css';
import {Button, Form, Input} from "antd";
import {submitAlliance} from "./service";
import responseMessage from "../../utils/ResponseMessage";

const Comment = () => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const [contentCount, setContentCount] = useState(0);

    const onFinish = async (values) => {
        setSubmitLoading(true);
        const {status, message} = await submitAlliance({...values});
        setSubmitLoading(false);

        if(status) {
            responseMessage.success('提交成功');
        } else {
            responseMessage.error(`提交失败, ${message}`);
        }
    };

    return(
        <div className={style.wrapper}>
            <div className={style.title}>留言</div>
            <Form
                style={{marginTop: 24}}
                size="large"
                onFinish={onFinish}
                initialValues={{content: ''}}
                onValuesChange={(changedValues) => {
                    changedValues.content && setContentCount(changedValues.content.length);
                }}
            >
                <Form.Item
                    label=" "
                    colon={false}
                    name="name"
                    rules={[{required: true, message: '姓名不能为空'}]}
                >
                    <Input placeholder="姓名" allowClear/>
                </Form.Item>
                <Form.Item
                    label=" "
                    colon={false}
                    name="phone"
                    rules={[{required: true, message: '电话不能为空'}]}
                >
                    <Input placeholder="电话" allowClear/>
                </Form.Item>
                <Form.Item
                    label=" "
                    colon={false}
                    name="company"
                    rules={[{required: true, message: '单位不能为空'}]}
                >
                    <Input placeholder="单位" allowClear/>
                </Form.Item>
                <Form.Item
                    label="&nbsp;&nbsp;&nbsp;"
                    colon={false}
                    style={{position: 'relative'}}
                >
                    <Form.Item name="content" noStyle>
                        <Input.TextArea style={{fontSize: 16}} placeholder="请在此输入留言内容 限制200字以内" autoSize={{minRows: 6}} maxlength={200}/>
                    </Form.Item>
                    <span style={{position: 'absolute', right: 0, bottom: 0, margin: '0 20px 12px'}}>{contentCount} / 200</span>
                </Form.Item>
                <Form.Item
                    style={{marginTop: 14, marginLeft: 20}}
                >
                    <Button type="primary" htmlType="submit" loading={submitLoading} style={{width: 300, background: '#000000', borderColor: '#000000'}}>
                        提交
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default Comment;

